import { CurrencyExchange } from '@mui/icons-material';
import TransactionManagement from './TransactionManagement';

export default {
    icon: CurrencyExchange,
    recordRepresentation: 'reference',
    list: TransactionManagement
};
